import { useQuery } from 'react-query';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { fetchData, joinDataArrays, reverseOrder } from './utils/functions';
import ItemSearch from './utils/item-search/ItemSearch';
import EditItemBtn from './utils/EditItemBtn';
import ChangeStatusBtn from './utils/ChangeStatusBtn';

export default function AssetPage() {
  const itemQuery = useQuery('itemData', () => fetchData('item'));
  const statusQuery = useQuery('statusData', () => fetchData('status'));
  const itemStatusQuery = useQuery('itemStatusData', () => fetchData('item-status'));
  const salesChannelQuery = useQuery('salesChannelData', () => fetchData('sales-channel'));
  const featuredImageQuery = useQuery('featuredImageData', () => fetchData('featured-image'));
  const [recentlyListedItems, setRecentlyListedItems] = useState(null);

  useEffect(() => {
    if (itemStatusQuery.data && statusQuery.data && salesChannelQuery.data && itemQuery.data && featuredImageQuery.data) {
      const sortedItemStatuses = itemStatusQuery.data.sort((a, b) => b.id - a.id);
      const itemStatusAndStatusData = joinDataArrays(
        sortedItemStatuses,
        'status_id',
        statusQuery.data,
        'id',
        { status: 'name' }
      );
      const itemStatusAndSalesChannelData = joinDataArrays(
        itemStatusAndStatusData,
        'sales_channel_id',
        salesChannelQuery.data,
        'id',
        { sales_channel: 'channel' }
      );
      const itemAndItemStatusData = joinDataArrays(
        itemQuery.data,
        'id',
        itemStatusAndSalesChannelData,
        'item_id',
        {
          status: 'status',
          entry_date: 'entry_date',
          status_id: 'status_id',
          sales_channel_id: 'sales_channel_id',
          sales_channel: 'sales_channel',
          review_date: 'review_date'
        },
        'statuses'
      );
      const listedItems = itemAndItemStatusData.filter((item) => item.statuses[0]?.status !== 'sold')
      const completeItemPreview = joinDataArrays(
        listedItems,
        'id',
        featuredImageQuery.data,
        'item_id',
        { featured_image: 'image' }
      );
      const listedItemsList = completeItemPreview.map((item) => (
        <div key={item.id} className="item">
          <div>
            <h3>{item.description}</h3>
            <Link to={`/cats/item/${item.id}`}>
              <img
                src={`${import.meta.env.VITE_API_URL}image/${item.featured_image}`}
                alt={item.featured_image}
                className="img"
                />
            </Link>
            <div>Platform: {item.statuses[0]?.sales_channel || 'N/A'}</div>
            <EditItemBtn itemId={item.id} />
            <ChangeStatusBtn itemId={item.id} />
          </div>
        </div>
      ));
      setRecentlyListedItems(reverseOrder(listedItemsList));
    }
  }, [itemStatusQuery.data, statusQuery.data, salesChannelQuery.data, itemQuery.data, featuredImageQuery.data]);

  return (
    <div>
      <ItemSearch />
      {itemQuery.isLoading || statusQuery.isLoading || salesChannelQuery.isLoading || itemStatusQuery.isLoading || featuredImageQuery.isLoading ? (
        <div>Loading...</div>
      ) : itemQuery.isError || statusQuery.isError || salesChannelQuery.isError || itemStatusQuery.isError || featuredImageQuery.isError ? (
        <div>Error fetching data</div>
      ) : (
        <>
          <h2>Recent Accessions</h2>
          <div className="items">
            {recentlyListedItems}
          </div>
        </>
      )}
    </div>
  );
}
